import {
    Button,
    HorizontalContainer,
    Modal,
    Panel,
    VerticalContainer,
} from '@/components';
import { InfoIcon } from '@/components/Icons';

import { R } from '@/caregiverSpace/resources/Texts.resx';

type PhoneCallCompletedModalProps = {
    onClose: () => void;
    onKeepConsultation: () => void;
    onRequestEndConsultation: () => void;
};

export const PhoneCallCompletedModal = ({
    onClose,
    onKeepConsultation,
    onRequestEndConsultation,
}: PhoneCallCompletedModalProps) => {
    return (
        <Modal
            title={R.ReplaceVideoConsultationWithCallTitle}
            onClose={onClose}
            className="max-w-[487px]"
        >
            <VerticalContainer>
                <VerticalContainer spacing="none">
                    <p>{R.PhoneCallCompletedMessage1}</p>
                    <p>{R.PhoneCallCompletedMessage2}</p>
                    <p>{R.PhoneCallCompletedMessage3}</p>
                </VerticalContainer>
                <Panel className="bg-(--color-bg-subtle)">
                    <VerticalContainer>
                        <InfoIcon variant="default" />
                        <p>{R.PhoneCallCompletedInfoBoxText}</p>
                    </VerticalContainer>
                </Panel>
                <HorizontalContainer>
                    <Button
                        variant="ghost"
                        fullWidth
                        onClick={onKeepConsultation}
                    >
                        {R.NoKeepConsultation}
                    </Button>
                    <Button
                        variant="secondary"
                        fullWidth
                        onClick={onRequestEndConsultation}
                    >
                        {R.YesEndConsultation}
                    </Button>
                </HorizontalContainer>
            </VerticalContainer>
        </Modal>
    );
};
